import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledLink = styled(Ds.Link)`
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    margin-right: 1rem;
`;
